(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvGameStaticSrc', function(vv) {
    var staticRoot = vv.getVvMetaData('static_root');
    return {
      priority: 99,
      restrict: 'A',
      link: function(scope, element, attrs) {
        attrs.$observe('vvGameStaticSrc', function(value) {
          if (!value || value.indexOf('/') !== 0)
          return;
          if (vv.getRegion() == 'cn') {
            attrs.$set('src', value);
          } else {
            attrs.$set('src', staticRoot + value);
          }
        });
      }
    };
  });
})(window, window.angular);
